module.exports = __webpack_public_path__ + "img/dept-10.8d02d1bb.svg";